import {
  FETCH_STORES_FULFILLED,
  STORES_REJECTED,
  STORES_PENDING,
  SET_STORE
} from "../constants/stores";

const initialState = {
  stores: [],
  currentStore: {},
  pending: true,
  error: {},
};

export const stores = (state = initialState, action) => {
  switch (action.type) {

    case STORES_PENDING:
      return {
        ...state,
        pending: true
      };

    case STORES_REJECTED:
      return {
        ...state,
        pending: false,
        error: action.error
      };

    case FETCH_STORES_FULFILLED:
      const storesKeys = Object.keys(action.response);
      let storesArray = storesKeys.map((el) => {
        return action.response[el];
      });
      return {
        ...state,
        pending: false,
        stores: [...storesArray],
        error: {}
      };

    case SET_STORE:
      return {
        ...state,
        pending: false,
        currentStore: action.response
      }

    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/stores.js